import React from 'react';

import { SecondaryButton } from '@components/Button/variants';
import AuthorUnit from '@components/FeedItems/AuthorUnit';
import useEventTracking from '@hooks/useEventTracking';
import type { ForumPost } from '@interfaces/homepage';
import { forum_post_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import MyTISection from './Section';
import { VIEW_ALL } from './constants';
import type { MyTICommunityInsightsProps } from './interfaces';

const MyTICommunityInsights = ({ forumPosts }: MyTICommunityInsightsProps) => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.ForumUnit,
  });

  const posts = forumPosts?.content as ForumPost[] | undefined;

  if (!posts || posts.length === 0) return null;

  const onForumPostClick = (post: ForumPost) => {
    trackEvent(
      click({ clickTarget: ClickTarget.ForumPost, contentId: post.id, clickText: post.title })
    );
  };

  const onViewAllClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ViewMore, clickText: VIEW_ALL }));
  };

  return (
    <Track>
      <MyTISection
        highlight="Label"
        subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
        title="Community & Insights"
      >
        <div className="relative mt-32 md:mt-48">
          <div className="grid grid-cols-2 gap-32 md:grid-cols-4 md:gap-24">
            {posts.map((post) => (
              <article
                key={post.id}
                className="mr-24 flex flex-col gap-24 border-0 border-r border-solid border-grayscale-gray last:border-r-0 last:pr-0"
              >
                <a
                  className="mt-16 block font-suisse-neue text-body-md font-normal text-black no-underline transition-colors duration-150 hover:text-primary-magenta"
                  href={forum_post_path(post.id)}
                  onClickCapture={() => onForumPostClick(post)}
                >
                  {post.title}
                </a>
                <AuthorUnit author={{ ...post.author, profileEnabled: true }} isRightRail />
              </article>
            ))}
          </div>
          <SecondaryButton
            as="link"
            className="mt-32 md:mt-48"
            href={forumPosts.viewAllUrl}
            onClickCapture={onViewAllClick}
          >
            {VIEW_ALL}
          </SecondaryButton>
        </div>
      </MyTISection>
    </Track>
  );
};

export default MyTICommunityInsights;
